module.exports = __webpack_public_path__ + "static/media/tabletostr.439ca2a1.svg";